module.exports = __webpack_public_path__ + "media/favicons/favicon_192-ee49e8e69c373093a91b526b51407fd7.png";